import Title from "common/Typography/Title";
import React, { CSSProperties, ReactNode, useEffect, useState } from "react";
import styled from "styled-components";
import Drawer from "common/Drawers/Drawer";
import { useVirtualKeyboard } from "utils/hooks/misc";

interface MobileFiltersDrawerProps {
  title?: string;
  triggerElement?: JSX.Element;
  content: ReactNode;
  rightButtons?: JSX.Element;
  open?: boolean;
  onClose?: () => void;
  contentStyle?: CSSProperties;
  shouldCloseDrawer?: boolean;
  setShouldCloseDrawer?: (shouldClose: boolean) => void;
  className?: string;
  footer?: ReactNode;
}

const BottomDrawer = ({
  title,
  triggerElement,
  content,
  rightButtons,
  open,
  onClose,
  contentStyle,
  shouldCloseDrawer,
  setShouldCloseDrawer,
  className,
  footer,
}: MobileFiltersDrawerProps) => {
  const { keyboardHeight } = useVirtualKeyboard();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (shouldCloseDrawer && isOpen) {
      setIsOpen(false);
      setShouldCloseDrawer?.(false);
    }
  }, [shouldCloseDrawer]);

  return (
    <>
      {!!triggerElement &&
        React.cloneElement(triggerElement, {
          onClick: (e) => {
            e.stopPropagation();
            setIsOpen(true);
          },
        })}
      <StyledDrawer
        placement="bottom"
        open={open ?? isOpen}
        onClose={(e) => {
          e.stopPropagation();
          onClose?.();
          setIsOpen(false);
        }}
        height="auto"
        $keyboardHeight={keyboardHeight}
        className={className}
      >
        {title?.length && (
          <TitleWrapper>
            <Title level={3}>{title}</Title>
            {rightButtons}
          </TitleWrapper>
        )}
        <ContentWrapper style={contentStyle}>{content}</ContentWrapper>
        {!!footer && <FooterWrapper>{footer}</FooterWrapper>}
      </StyledDrawer>
    </>
  );
};

export default BottomDrawer;

const StyledDrawer = styled(Drawer)<{ $keyboardHeight?: number }>`
  .ant-drawer-content-wrapper {
    max-height: 500px;
    height: auto !important;
  }
  &.ant-drawer-content {
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    ${(p) =>
      p.$keyboardHeight &&
      `
      padding-bottom: ${p.$keyboardHeight}px;
    `};
  }
  .ant-drawer-body {
    padding: 0 !important;
    overflow: hidden !important;
  }
  .ant-drawer-close {
    display: none;
  }
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
`;
const TitleWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid ${(p) => p.theme.colors.lightBorderGrey};
`;
const ContentWrapper = styled.div`
  padding: 16px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
=`;
const FooterWrapper = styled.div`
  padding: 16px;
  position: relative;
  bottom: 0;
  width: 100%;
  background: ${(p) => p.theme.colors.layoutBgColor};
`;
